var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush } from "./utils";
export function videoInteraction(e) {
    var details = e.detail || {};
    var videoData = normalizeObject(__assign({ event: "video_interactions", event_action: "video_interactions" }, details));
    dataLayerPush(videoData);
}
export function videoAssetInteraction(e) {
    var details = e.detail || {};
    var videoDownloadData = normalizeObject(__assign({ event: "video_asset_interaction", event_action: "video_asset_interaction", lead_nurture_interaction: 1 }, details));
    dataLayerPush(videoDownloadData);
}
